<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card mt-4">
          <div class="card-header">
            <h5 class="mb-0">vCloud Director</h5>
            <p class="mb-0">
              Aus Sicherheitsgründen ist das Portal nur eingeschränkt über das Internet erreichbar. Für den <b>temporären</b> Zugriff ist eine manuelle Freigabe Ihrer öffentlichen IP 
              (<strong v-if="ip">{{ ip }}</strong>
              <span v-else>…</span>)
              notwendig.<br/>
              Nach erfolgter Freigabe ist der {{ portalName }} über 
              <a href="https://control.twl-kom.de" target="_blank"><b>control.twl-kom.de</b></a> für <b>30 Minuten</b> erreichbar. Danach muss die Freigabe erneut beantragt werden.<br/><br/>

              Aktueller Status: <strong v-if="ip"><b>{{ status }}</b></strong>
              <span v-else>…</span>
              <span><i>Hinweis: Pilot</i></span>
            </p>
          </div>
          <div class="card-body">
            <!-- Wenn IP bereits freigegeben ist -->
            <template v-if="buttonState === 'active'">
              <a href="https://control.twl-kom.de" target="_blank">
                <material-button
                  variant="filled"
                  color="success">
                  Weiter zu control.twl-kom.de
                </material-button>
              </a>
            </template>

            <!-- Wenn IP noch freigegeben werden muss -->
            <template v-else>
              <material-button
                variant="filled"
                color="primary"
                :disabled="buttonState === 'loading'"
                @click="triggerVcloud">
                Zugriff für IP anfragen
              </material-button>
            </template>

            <div v-if="responseMsg" class="mt-3">
              <p class="text-success">{{ responseMsg }}</p>
            </div>
            <div v-if="errorMsg" class="mt-3">
              <p class="text-danger">{{ errorMsg }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import MaterialButton from "@/components/MaterialButton.vue";

export default {
  name: "VcloudTrigger",
  components: {
    MaterialButton,
  },
  data() {
    return {
      ip: "",
      responseMsg: "",
      errorMsg: "",
      buttonState: "loading", // loading, ready, active,
      portalName: "VMware Cloud Director"
    };
  },
  mounted() {
    this.fetchClientIp();
  },
  methods: {
    async fetchClientIp() {
      try {
        const url = this.$path + "api/proxy/v1/ip";
        const res = await axios.get(url, this.$settings);
        this.ip = res.data.response;
        this.checkVcloudStatus();
      } catch (error) {
        this.errorMsg = "IP konnte nicht ermittelt werden: " + (error.response?.data?.message || error.message);
        this.buttonState = "ready";
      }
    },

    async checkVcloudStatus() {
      try {
        const url = this.$path + "api/proxy/v1/status";
        await axios.get(url, this.$settings);
        this.buttonState = "active"; // Freigabe besteht -> Button verlinkt
        this.status = "Öffentliche-IP freigegeben."
      } catch (error) {
        if (error.response?.status === 400) {
          this.buttonState = "ready"; // Noch keine Freigabe -> Trigger-Button
          this.status = "Freigabe ausstehend."
        } else {
          this.errorMsg = "Fehler beim Statuscheck: " + (error.response?.data?.message || error.message);
        }
      }
    },

    async triggerVcloud() {
      try {
        const url = this.$path + "api/proxy/v1/911dc79e-83be-4409-8248-7cab7b481c84";

        // Warte auf die Antwort des POST-Aufrufs
        await axios.post(url, { ip: this.ip }, this.$settings);

        // Setze die Erfolgsmeldung
        //this.responseMsg = "Erfolgreich gesendet: " + JSON.stringify(res.data);

        // Nun sicher den Status erneut prüfen
        await this.checkVcloudStatus();

      } catch (error) {
        this.errorMsg = "Fehler beim Senden: " + (error.response?.data?.message || error.message);
        this.responseMsg = "";
      }
    }
  },
};
</script>

<style scoped>
.text-success {
  color: #28a745;
}

.text-danger {
  color: #dc3545;
}
</style>
